import React from "react";
import DSToggle from "Components/DesignSystem/Toggle/Toggle";

/**
 * Thin adapter over the DS Toggle (2026-09-05) keeping this module's historical
 * contract: `name` derives the DOM id, the `name` attribute AND the testid —
 * several specs (and CategoryMappingTable.interactions.test.tsx) select by any
 * of the three. The control is a `<button role="switch">` now, so checked-ness
 * is `aria-checked` (jest-dom's `toBeChecked` reads it) and `onChange` hands the
 * next boolean directly instead of a change event. The switch sits in the
 * Consider column of every mapping table — the column header carries the visual
 * meaning, the aria-label carries it for a screen reader.
 */
const Toggle = ({
    value,
    onChange,
    disabled,
    name
}: {
    value: boolean;
    onChange: (checked: boolean) => void;
    disabled: boolean;
    name: string;
}) => (
    <DSToggle
        label=""
        aria-label="Consider"
        checked={value}
        onChange={(checked) => onChange(checked)}
        disabled={disabled}
        id={name}
        name={name}
        data-testid={name}
    />
);

export default Toggle
